module.exports = __webpack_public_path__ + "img/orange-info.0aaf1b54.svg";